module.exports = __webpack_public_path__ + "media/header/outbound_icon_black-6ce7fc9e.svg";